// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\ServicesV2\Messages\DataProviders\MessageField
// Generated on: <normalized>

export enum MessageField {
  DB_TABLE = 'messages',
  DB_IDENTIFIER = 'messageGUID',
  TYPE = 'type',
  STATUS = 'status',
  MESSAGE_DATA = 'messageData',
  ALT_MESSAGE_DATA = 'altMessageData',
  ATTACHMENT_DATA = 'attachmentData',
  MAIL_TEMPLATE = 'mailTemplate',
  RECIPIENT_DATA = 'recipientData',
  EMAIL_ACCOUNT_GUID = 'emailAccountGUID',
  SENT_ON = 'sent_on',
  X_PRIORITY = 'x_priority',
  X_MAILER = 'x_mailer',
  IMPORTANCE = 'importance',
  ENCODING = 'encoding',
  AUTO_SUBMITTED = 'auto_submitted',
  UNSUBSCRIBE_URL = 'unsubscribeUrl',
  IS_HTML = 'is_html',
  SCHEDULED_FOR = 'scheduledFor',
  REPEAT_FREQUENCY_METRIC = 'repeatFrequencyMetric',
  REPEAT_FREQUENCY_VALUE = 'repeatFrequencyValue',
  CREATED_BY = 'createdByUserGUID',
  APPROVED_BY = 'approvedByUserGUID',
  CHARSET = 'charset',
  EMAIL_MESSAGE_ID = 'emailMessageID',
  APPROVAL_DATA = 'approvalData',
}

export const MessageFieldGetEncryptionFields = [] as const;

export const MessageFieldCases = ["messages", "messageGUID", "type", "status", "messageData", "altMessageData", "attachmentData", "mailTemplate", "recipientData", "emailAccountGUID", "sent_on", "x_priority", "x_mailer", "importance", "encoding", "auto_submitted", "unsubscribeUrl", "is_html", "scheduledFor", "repeatFrequencyMetric", "repeatFrequencyValue", "createdByUserGUID", "approvedByUserGUID", "charset", "emailMessageID", "approvalData"] as const;
